import React from 'react'

export default function Education() {
    return (
        <section id="education" className="section is-medium">
            <p className="title  is-family-code has-text-green">What I've Learned</p>
            <div class="columns is-mobile">
                <div class="column is-11 is-offset-1">
                    <div className="columns is-vcentered">
                        <div className="column">
                            <div class="notification is-primary">
                                <p className="bd-notification title is-2 has-text-light is-family-code">MS in Computer Science </p>
                                <text className='is-family-code'>@University Of North Carolina At Charlotte
                                    <br />- Augest 2021 - May 2023 <br />- 4.0 GPA</text>
                            </div>
                        </div>
                        <div className="column">
                            {/* <p className="bd-notification title is-2 has-text-light">EMIE v2.1</p> */}
                        </div>
                    </div>
                    <div className="columns is-vcentered">
                        <div className="column">
                            {/* <p className="bd-notification title is-2 has-text-light has-text-centered">Voicebot</p> */}
                        </div>
                        <div className="column">
                            <div class="notification is-primary">
                                <p className="bd-notification title is-2 has-text-light is-family-code">Bachelor's of Engineering in Information Techology</p>
                                <text className='is-family-code'> @University Of Mumbai (KGCE)
                                    <br />- Augest 2012 - May 2016 <br />- 63.10%</text>
                            </div>
                        </div>
                    </div>
                    <div className="columns is-vcentered">
                        <div className="column">
                            <div class="notification is-primary">
                                <p className="bd-notification title is-2 has-text-light is-family-code">SSC</p>
                                <text className='is-family-code'>@DS High School, Sion <br />
                                    -Augest 2010 Passout<br />-90.55%</text>
                            </div>
                        </div>
                        <div className="column">
                            {/* <p className="bd-notification title is-2 has-text-light">EMIE v2.1</p> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
